module.exports = __webpack_public_path__ + "static/media/lafluence.47f75e2c.jpg";